export default __webpack_public_path__ + "static/media/e79514f7-dfde-44b9-b780-573fa90019c0.7894a237.png";